import { AUTH_BASE_URL } from "../../props";
import {
  useDelete,
  useGet,
  usePost,
  usePostWithoutLocation,
  usePut,
} from "../../common/fetchServices";

const papiServerUrl = `${AUTH_BASE_URL}/papi/servers`;
const getPapiServersUrl = () => papiServerUrl;
const getPapiServerUrl = ({ id }) => `${papiServerUrl}/${id}`;

const getOrgPapiServerUrl = ({ organizationId }) =>
  `${AUTH_BASE_URL}/organizations/${organizationId}/authentication/papi`;
const getOrgPapiServerPrefixUrl = ({ organizationId }) =>
  `${AUTH_BASE_URL}/organizations/${organizationId}/authentication/papi/prefixes`;

export const usePapiServers = () => {
  const url = `${papiServerUrl}?limit=9999&offset=0`;
  return useGet(["papi_servers"], url);
};

export const useCreatePapiServer = () => {
  return usePostWithoutLocation(getPapiServersUrl, {
    queriesToInvalidate: [["papi_servers"]],
  });
};

export const useUpdatePapiServer = () => {
  return usePut(getPapiServerUrl, { queriesToInvalidate: [["papi_servers"]] });
};

export const useDeletePapiServer = () => {
  return useDelete(getPapiServerUrl, {
    queriesToInvalidate: [["papi_servers"]],
  });
};

export const usePapiAuthenticationCreate = () => {
  return usePost(getOrgPapiServerUrl, {
    queriesToInvalidate: [["papi_authentication"], ["organizationId"]],
  });
};

export const usePapiAuthenticationUpdate = () => {
  return usePut(getOrgPapiServerUrl, {
    queriesToInvalidate: [["papi_authentication"], ["organizationId"]],
  });
};

export const usePapiPrefixUpdate = () => {
  return usePut(getOrgPapiServerPrefixUrl, {
    queriesToInvalidate: [["papi_authentication"], ["organizationId"]],
  });
};
